<template>
	<article class="ideas-app-result">
		<div v-if="matches.length > 0" class="ideas-app-result-matches">
			<p>
				Best for <span>{{ matches.length }}</span> matching {{ matches.length === 1 ? 'filter' : 'filters' }}
			</p>

			<div>
				<span v-for="term in matches" :key="term.key + '-' + term.value">{{ term.label }}</span>
			</div>
		</div>

		<div class="ideas-app-result-inner">
			<div class="ideas-app-result-header">
				<header>
					<h2 v-html="item.title" />

					<p v-if="item.rate">
						{{ item.rate }}
					</p>

					<p v-else>Earnings Vary</p>
				</header>

				<div v-if="item.description">
					<p>{{ item.description }}</p>
				</div>
			</div>

			<div v-if="item.columns.length > 0" class="ideas-app-result-content">
				<h3>The Basics</h3>

				<nav v-if="item.columns.length > 0">
					<button
						v-for="(column, c_idx) in item.columns"
						:key="c_idx"
						type="button"
						:class="'btn ' + (selected_c_idx === c_idx ? 'active' : '')"
						@click="set_tab(c_idx)"
					>
						{{ column.heading }}
					</button>
				</nav>

				<div class="inner">
					<div
						v-for="(column, c_idx) in item.columns"
						:key="c_idx"
						:class="'block ' + (selected_c_idx === c_idx ? 'active' : '')"
					>
						<h4 v-if="column.heading">
							{{ column.heading }}
						</h4>

						<div class="scroll">
							<div>
								<div v-if="get_total(column.groups) > 0" class="progress">
									<span>{{ get_selected(column.groups) }}/{{ get_total(column.groups) }}</span>

									<div class="bar">
										<span
											:style="{
												width:
													(get_selected(column.groups) / get_total(column.groups)) * 100 +
													'%',
											}"
										/>
									</div>
								</div>

								<template v-for="(group, g_idx) in column.groups" :key="g_idx">
									<h5 v-if="group.subheading">
										{{ group.subheading }}
									</h5>

									<ul v-if="group.style === 'list'">
										<li v-for="(group_item, gi_idx) in group.items" :key="gi_idx">
											{{ group_item.label }}
										</li>
									</ul>

									<fieldset v-else-if="group.style === 'checklist'">
										<label
											v-for="(group_item, gi_idx) in group.items"
											:key="gi_idx"
											class="checkbox"
										>
											<input v-model="group_item.selected" type="checkbox" />
											<v-icon slug="check" />
											<span>{{ group_item.label }}</span>
										</label>
									</fieldset>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>

			<footer v-if="item.related.length > 0" class="ideas-app-result-related">
				<h3>Articles</h3>

				<div class="inner">
					<a v-for="related_item in get_related()" :key="related_item.id" :href="related_item.url">
						<div v-if="related_item.image" v-html="related_item.image" />

						<p>{{ related_item.title }}</p>
					</a>
				</div>

				<div v-if="item.related.length > per_page && !is_showing_all" class="show-more">
					<button type="button" class="btn btn-bordered small" @click="show_all">
						Reveal (<strong>{{ item.related.length - per_page }}</strong
						>) More
					</button>
				</div>
			</footer>
		</div>
	</article>
</template>

<script setup>
import { computed, ref } from 'vue';

import { store } from '../jobs-app/_store.js';
import VIcon from '../jobs-app/_v-icon.vue';

const props = defineProps({
	item: {
		type: Object,
		required: true,
	},
	selected_filters: {
		type: Object,
		required: true,
	},
});

const matches = computed(() => {
	const items = [];

	for (const key of store.filter_keys) {
		for (const term of store.filters[key].terms) {
			if (props.selected_filters[key].indexOf(term.value) === -1) {
				continue;
			}

			if (props.item.filters[key].indexOf(term.value) === -1) {
				continue;
			}

			items.push({
				key,
				value: term.value,
				label: term.label,
			});
		}
	}

	return items;
});

const selected_c_idx = ref(0);

const per_page = ref(4);

const is_showing_all = ref(false);

function set_tab(c_idx) {
	selected_c_idx.value = c_idx;
}

function get_selected(groups) {
	let count = 0;
	for (const group of groups) {
		if (group.style !== `checklist`) {
			continue;
		}

		const selected = group.items.filter((item) => item.selected);

		count += selected.length;
	}

	return count;
}

function get_total(groups) {
	let count = 0;
	for (const group of groups) {
		if (group.style !== `checklist`) {
			continue;
		}

		count += group.items.length;
	}

	return count;
}

function get_related() {
	if (is_showing_all.value) {
		return props.item.related;
	}

	return props.item.related.slice(0, per_page.value);
}

function show_all() {
	is_showing_all.value = true;
}
</script>
